import { Button, FormControl, FormLabel, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from "@chakra-ui/react"
import React from "react"

export interface DeleteInterface {
    isOpen: boolean;
    delete: (deleteEnity:boolean) => void;
    onClose: () => void;
}

const DeleteModal = (props: DeleteInterface ) => {


  const initialRef = React.useRef(null)
  const finalRef = React.useRef(null)

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={props.isOpen}
        onClose={props.onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>DELETE</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Are you sure you want to delete?</FormLabel>
            </FormControl>

           </ModalBody>

          <ModalFooter>
            <Button onClick={(e) => {props.delete(true); props.onClose()} }colorScheme='blue' mr={3}>
              Yes
            </Button>
            <Button onClick={props.onClose}>No</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default DeleteModal;